
module.directive('studentContactInfoForm', function(ModelService) {
    var fields = ['participant_email', 'participant_phone',
                  'participant_street', 'participant_city',
                  'participant_state_abbr', 'participant_postal_code',
                  'participant_twitter', 'participant_facebook'];
    return {
        restrict: 'E',
        templateUrl: 'students/demographics/studentContactInfoForm',
        scope: {participant: '=', states: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = ModelService.copyFields(scope.participant, fields);
            basicForm.data = scope.data;
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.participant, data);
            };
        },
    };
});